import React, { useState, useEffect } from 'react';
import './ruletaCandado.css'; // Importa el archivo CSS

const RuletaNumero = ({ targetNumber, delay, start=false, finish, length, index }) => {
    // console.log('length',length)
    // console.log('index', index+1)
  const [currentNumber, setCurrentNumber] = useState(0);
  const [spinning, setSpinning] = useState(true);
  const [animationSpeed, setAnimationSpeed] = useState(0.1); // Iniciar con una velocidad base

  useEffect(() => {
    if(start){
        let interval;
        let speed = 10; // Iniciar la velocidad de intervalo en 200 ms

        if (spinning) {
        interval = setInterval(() => {
            setCurrentNumber((prev) => (prev + 1) % 10);

            // Aumentar el tiempo del intervalo en 100ms por vuelta
            speed += 100;

            // Ajustar la velocidad de la animación en función del incremento
            // setAnimationSpeed(speed / 1000); // Convertimos a segundos para usar en CSS

            // Limpiar el intervalo actual y establecer uno nuevo con el tiempo incrementado
            clearInterval(interval);
            interval = setInterval(() => {
            setCurrentNumber((prev) => (prev + 1) % 10);
            }, speed);
        }, speed);
        }
        // Detener la rueda después de un tiempo y fijar el número objetivo
        const stopSpinning = setTimeout(() => {
          clearInterval(interval);
          setCurrentNumber(targetNumber);
          setSpinning(false);
          setAnimationSpeed(0)
          if(index+1 === length){
              finish(true)
          }
        }, delay);
        return () => {
          clearInterval(interval);
          clearTimeout(stopSpinning);
        };
    }

  }, [spinning, targetNumber, delay, start]);

  return (
    <div className="ruleta-wheel">
      <div
        className="ruleta-number"
        style={{ animation: `spin ${start ? animationSpeed : 0}s ease-in-out infinite` }}
      >
        {currentNumber}
      </div>
    </div>
  );
};

export default RuletaNumero;
